import { connect } from 'react-redux';

import { DATE_FORMAT_ISO_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  getDecisionData,
  getDecisionDataCreatedAt,
  getDecisionDataDecisionId,
  getDecisionStatus,
} from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { DecisionErrorsIcon } from 'DecisionPackage/DecisionHeaderModule/components/DecisionErrorsIcon';
import { formatDateLocale, getFormatedClientTime } from 'CorePackage/MainModule/common/formatDate';

import styles from './KnmInfo.module.scss';
import { getIsSticked } from '../reducers/headerReducer';
import { DecisionStatusHint } from '../../../KnmPackage/KnmHeaderModule/components/DecisionStatusHint';

interface IDecisionHeaderStoreProps {
  status: IKnmStatus | undefined;
  isDecisionDataExist: boolean;
  decisionId: string | undefined;
  decisionCreatedAt: string | null | undefined;
  isSticked: boolean;
}

interface IDecisionInfoProps {
  isHover: boolean;
}

const DecisionInfoWithoutStore = ({
  status,
  decisionId,
  decisionCreatedAt,
  isDecisionDataExist,
  isSticked,
  isHover,
}: IDecisionHeaderStoreProps & IDecisionInfoProps) => {
  const containerAttributes = {
    ...(isSticked && { 'data-visible': true }),
  };

  return (
    <div className={styles.Container} {...containerAttributes}>
      <h3 className={styles.Title}>{`Решение ${decisionId ?? ''}`.trim()}</h3>
      {(!isDecisionDataExist || decisionCreatedAt || !decisionId) && (
        <small className={styles.Date}>
          {` от ${
            decisionCreatedAt
              ? formatDateLocale({
                  date: decisionCreatedAt,
                  dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
                  parseFormat: DATE_FORMAT_ISO_FNS,
                })
              : getFormatedClientTime(DATE_FORMAT_LONG_MINUTE_FNS)
          }`}
        </small>
      )}
      {status && (
        <>
          <span>&nbsp;</span>
          <span className={styles.Status}>{status.name}</span>/
        </>
      )}
      <DecisionStatusHint isHover={isHover} />
      <DecisionErrorsIcon className={styles.ErrorsIcon} autoHidingTooltip="onHeaderStickOff" />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IDecisionHeaderStoreProps => ({
  status: getDecisionStatus(state),
  isDecisionDataExist: !!getDecisionData(state),
  decisionId: getDecisionDataDecisionId(state),
  decisionCreatedAt: getDecisionDataCreatedAt(state),
  isSticked: getIsSticked(state),
});

export const DecisionInfo = connect(mapStateToProps)(DecisionInfoWithoutStore);
